import React, { useEffect } from 'react';
import './assets/scss/themes.scss';
import './assets/scss/quill-editor.scss';
import RouteIndex from 'Routes/Index';
import CrashlyticsService from './services/crashlyticsService';
import QueryProvider from './providers/QueryProvider';

function App() {
  useEffect(() => {
    // Initialize crashlytics service only after user is authenticated
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      try {
        const token = JSON.parse(authUser);
        if (token && token !== "") {
          CrashlyticsService.getInstance();
        }
      } catch (error) {
        console.warn('Failed to parse auth user data');
      }
    }
  }, []);

  return (
    <QueryProvider>
      <RouteIndex />
    </QueryProvider>
  );
}

export default App;
